/**
 * Fenice Italy Business API
 * # Fenice Italy Business API  ## General Http Status: HTTP STATUS CODE | DESCRIPTION --- | --- 400 | Business error or general error 401 | Expired token 403 | Access token does not have the required scope 404 | Not found 500 | Internal error  ## Specific Error Codes: Verti has specific errors based on validations, in error field *code*  CODE | DESCRIPTION --- | --- KOIT001 | Plate not valid from SIC/SITA. KOIT002 | Vehicle plate number is not valid. KOIT003 | Login failed. Password is not correct.  ## Annotations:   - In those services that return a list of items, in the case of not found any of them, it will return an empty list.   - For date format, standard ISO 8601. (YYYY-MM-DDThh:mm:ss.sTZD)
 *
 * OpenAPI spec version: 1.2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * For Self Claims the response returns information for the Policy:   {     \"userId\": \"1019259084\",     \"sessionId\": \"9QWL7JVX5y71ytIHoaOLGwzTp\",     \"sectorCode\": \"HomePRHLine\",     \"policy\": {       \"policyId\": \"HOM0412423500-1\",       \"policyNumber\": \"HOM0412423500-1\",       \"policyPeriodId\": \"pc:132000004\",       \"effectiveDate\": \"2023-10-25T02:00:00.000+0200\",       \"dueDate\": \"2024-10-25T02:00:00.000+0200\",       \"homeRisk\": {         \"riskId\": \"0\"       },       \"coverageEndDate\": \"2023-11-25T02:00:00.000+0100\"     },     \"isBackOfficeUser\": false   }  And for Q&B returns just the policyId: {   \"userId\": \"2134001058\",   \"sessionId\": \"sessionId1\",   \"policy\": {     \"policyId\": \"HOM0097337662\"   },   \"isBackOfficeUser\": false }
 */
export interface LoginResponse {
  /**
   * authentication token (JWT). It has the same payload as refreshToken.
   */
  token: string;
  /**
   * refresh token expiration date and time
   */
  exp: number;
  /**
   * refresh token (JWT). It has the same payload as token.
   */
  refreshToken: string;
}
